"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getTableColumn = columnData => {
  const isCentered = columnData.isCentered !== undefined && columnData.isCentered ? 'is-vcentered' : '';
  const columnTitle = columnData.columnTitle ? columnData.columnTitle : columnData.columnName;
  return {
    Header: columnData.columnName,
    id: columnData.dataAttribute,
    accessor: columnData.dataAttribute,
    Cell: function getCol(_ref) {
      let {
        row
      } = _ref;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "is-hidden-tablet"
      }, /*#__PURE__*/_react.default.createElement("b", null, columnTitle)), /*#__PURE__*/_react.default.createElement("div", {
        className: isCentered
      }, columnData.valueFunction ? columnData.valueFunction(row) : row.value));
    }
  };
};
var _default = exports.default = getTableColumn;
//# sourceMappingURL=TableColumn.js.map